// @ts-strict-ignore
import {Component, Input, OnChanges, SimpleChanges, output} from "@angular/core";

@Component({
	selector: "sim-slide-toggle-if-else",
	templateUrl: "./sim-slide-toggle-if-else.component.html",
	styleUrls: ["./sim-slide-toggle-if-else.component.scss"],
	standalone: false,
})
export class SimSlideToggleIfElseComponent implements OnChanges {
	@Input() checked: boolean = false;
	@Input() enableUntouchedState: boolean = false;
	@Input() defaultChecked: boolean = false;
	@Input() disabled: boolean = false;
	checkedEmitter = output<boolean>();
	@Input() toolTipFirstOption: string;
	@Input() toolTipSecondOption: string;

	setChecked(inputChecked?: boolean): void {
		if (this.disabled) return;
		this.checked = this.checked === null ? inputChecked : !this.checked;
		this.checkedEmitter.emit(this.checked);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes["defaultChecked"]) return;
		if (this.defaultChecked && changes["defaultChecked"].previousValue !== changes["defaultChecked"].currentValue) {
			this.setChecked();
		}
	}
}
